// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"_1YQJK"};